module.exports = __webpack_public_path__ + "img/settings.2050028c.svg";